module.exports = __webpack_public_path__ + "static/media/color_gen.f552c2b8.jpeg";